import { createColumnHelper } from "@tanstack/react-table";
import * as React from "react";
import { useMemo } from "react";
import RowCheckbox from "components/common/EntityDataTable/RowCheckbox";
import { BULK_SELECT_COL_ID } from "components/common/EntityDataTable/Constants";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
const BulkSelectHeader = ({ table }) => {
  var _a, _b;
  const { isSomeRowsSelected, isAllRowsSelected } = useSelectedEntities();
  const title = `${isAllRowsSelected ? "Deselect" : "Select"} all visible entities`;
  return /* @__PURE__ */ React.createElement(
    RowCheckbox,
    {
      onChange: table.getToggleAllRowsSelectedHandler(),
      checked: isAllRowsSelected,
      indeterminate: isSomeRowsSelected,
      title,
      disabled: !((_b = (_a = table.options) == null ? void 0 : _a.data) == null ? void 0 : _b.length),
      "aria-label": title
    }
  );
};
const BulkSelectCell = ({ row }) => {
  const { selectedEntities } = useSelectedEntities();
  return /* @__PURE__ */ React.createElement(
    RowCheckbox,
    {
      onChange: row.getToggleSelectedHandler(),
      title: `${row.getIsSelected() ? "Deselect" : "Select"} entity`,
      checked: selectedEntities.includes(row.id),
      disabled: !row.getCanSelect()
    }
  );
};
const useBulkSelectColumnDefinition = (displayBulkSelectCol, colWidth) => {
  const columnHelper = createColumnHelper();
  return useMemo(
    () => displayBulkSelectCol ? columnHelper.display({
      id: BULK_SELECT_COL_ID,
      size: colWidth,
      header: BulkSelectHeader,
      enableHiding: false,
      cell: BulkSelectCell,
      enableResizing: false
    }) : null,
    [displayBulkSelectCol, columnHelper, colWidth]
  );
};
export default useBulkSelectColumnDefinition;
